import { Box, ListItem, OrderedList, Text } from '@chakra-ui/layout';
import React from 'react';
import { Card } from '../../../components/Card';
import { useConfig } from '../../../hooks/useConfig';
import { FirebaseCourseWithUidAndRegistration } from '../../../types/types';

interface AdminCourseRegistrationItemProps {
  course: FirebaseCourseWithUidAndRegistration;
}

export const AdminCourseRegistrationItem: React.FC<AdminCourseRegistrationItemProps> =
  ({ course }) => {
    const firebaseConfig = useConfig();

    const remainingRegistrants =
      course.maxParticipants! - course.registrants.length;
    const isFullCourse = remainingRegistrants <= 0;

    return (
      <Card
        animate={true}
        title={course.title}
        headerComponent={
          <Text color="white" whiteSpace="nowrap">
            {course.date.format('LLLL')}
          </Text>
        }
      >
        <Box>
          <Text fontWeight="bold" color={isFullCourse ? 'red' : 'green'}>
            Noch {remainingRegistrants} freie Plätze{' '}
          </Text>
        </Box>
        <Box>
          <OrderedList>
            {course.registrants.map((registrant) => (
              <ListItem
                mt={2}
                key={`registrant${registrant.id}`}
              >{`${registrant.displayName} (${registrant.email})`}</ListItem>
            ))}
          </OrderedList>
        </Box>
      </Card>
    );
  };
